import { render } from "./KanbanBoardsPage.vue?vue&type=template&id=6db4fab4&ts=true"
import script from "./KanbanBoardsPage.vue?vue&type=script&lang=ts"
export * from "./KanbanBoardsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__